import * as React from 'react';
import { Modal, Button, CloseButton } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './styles/ModalDragDropImport.scss';
import BodyDragDropImport from './BodyDragDropImport';

export class ModalDragDropImportClass extends React.Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
			isDisableDoneButton: true,
		}
	}

	switchStateDoneButton = (value) => {
		this.setState({
			isDisableDoneButton: value,
		})
	}


	render() {
		const { i18n,
			show,
			handleConfirmation,
			toggleModalDragDrop,
			title,
			tree,
			allLists,
			addRemoveItem,
			checkForEmptyList,
			getDataCSVImported,
		} = this.props;

		return (
			// cacc-theme.css requires class of 'show' on dialog and backdrop
			<Modal
				show={show}
				className={`modal-drag-drop-container ${show ? 'show' : ''} `}
				backdropClassName={show ? 'show' : ''}
				onHide={() => toggleModalDragDrop(false)}
			>
				<Modal.Header>
					<Modal.Title>
						{title}
					</Modal.Title>
					<button onClick={() => toggleModalDragDrop(false)} className='close-button'>&times;</button>
				</Modal.Header>

				<Modal.Body>
					<BodyDragDropImport
						switchStateDoneButton={this.switchStateDoneButton}
						isDisableDoneButton={this.state.isDisableDoneButton}
						tree={tree}
						allLists={allLists}
						addRemoveItem={(id, isAdding) => { addRemoveItem(id, isAdding) }}
						checkForEmptyList={checkForEmptyList}
						getDataCSVImported={getDataCSVImported}
					/>
				</Modal.Body>

				<Modal.Footer>
					<Button
						onClick={() => toggleModalDragDrop(false)}
						bsStyle='default'
					>
						{i18n.t('CANCEL')}
					</Button>
					<Button
						onClick={handleConfirmation}
						bsStyle='primary'
						className='done-button'
						disabled={this.state.isDisableDoneButton}
					>
						{i18n.t('SAVE_DIST_LIST')}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

ModalDragDropImportClass.propTypes = {
	show: PropTypes.bool.isRequired,
	tree: PropTypes.shape({}).isRequired,
	allLists: PropTypes.array.isRequired,
	handleConfirmation: PropTypes.func.isRequired,
	toggleModalDragDrop: PropTypes.func.isRequired,
	addRemoveItem: PropTypes.func.isRequired,
	checkForEmptyList: PropTypes.func.isRequired,
	getDataCSVImported: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	i18n: PropTypes.shape({}).isRequired,
};

ModalDragDropImportClass.defaultPropTypes = {
	closeButtonClass: '',
}

export default withTranslation()(ModalDragDropImportClass);
